export default __webpack_public_path__ + "2f79d369e40e8716839dff557a0b574f.svg";